import { FC, HTMLProps } from 'react';
import s from './container.module.css';
import cn from 'classnames';
import { Label } from '../label/label';

interface Props extends HTMLProps<HTMLDivElement> {
  isHorizontal?: boolean;
}

export const Container: FC<Props> = (props) => {
  const { className, label, required, children, isHorizontal, ...other } = props;

  return (
    <div className={cn(s.component, className, isHorizontal && s.isHorizontal)} {...other}>
      {label && <Label required={required}>{label}</Label>}
      {children}
    </div>
  );
};
